/**
 * PC申請成功提示頁面
 */
/* eslint-disable react/jsx-max-depth */
import React from 'react';
import { useIntl, history } from 'umi';
import { Divider } from 'antd';
import classPrefix from 'prefix-classnames';
import FooterButton from '@/components/FooterButton';
import Breadcrumb from '@/components/Breadcrumb';

import './WebComplete.less';
import { getWebFosterBreadcrumbItems } from '@/utils/Breadcrumb';

const px = classPrefix('web-complete') as (param: string) => string;

export default function WebComplete() {
  const intl = useIntl();
  const { status, msg, submitTime } = history.location.query || {};

  const getMsg = (msg: Array<string | null> | null | string): string => {
    // 如果取消状态为1，直接显示已取消
    switch (msg) {
      case 'exist':
        return intl.formatMessage({ id: '在評估未完成之前，不可新增申請。' });
      default:
        return intl.formatMessage({ id: '保存申請失敗！您可嘗試再次申請。' });
    }
  };

  return (
    <>
      <div className={px('root')}>
        {/* 面包屑 */}
        <div className={px('breadcrumb')}>
          <Breadcrumb itemList={getWebFosterBreadcrumbItems()} />
        </div>
        <div className={px('title')}>{intl.formatMessage({ id: '申請成為寄養父母' })}</div>
        {status === 'true' && (
          <div className={px('container')}>
            <div className={px('header')}>
              <div className={px('img')}>
                <div className={px('tick')} />
              </div>
              <div className={px('successWarn')}>
                {intl.formatMessage({ id: '成功提交申請' })}
              </div>
            </div>
            <Divider className={px('dashedDivider')} />
            <div className={px('content')}>
              <div className={px('successInfoArea')}>
                <div className={px('infoItem')}>
                  <div className={px('itemKey')}>{intl.formatMessage({ id: '申請編號' })}</div>
                  <div className={px('itemNumber')}>{msg}</div>
                </div>
              </div>
              <div className={px('successInfoArea')}>
                <div className={px('infoItem')}>
                  <div className={px('itemKey')}>{intl.formatMessage({ id: '申請時間' })}</div>
                  <div className={px('itemNumber')}>{submitTime}</div>
                </div>
              </div>
              <Divider className={px('dashedDivider')} />
              <div className={px('successMsg')}>
                {intl.formatMessage(
                  {
                    id: '填寫申請資料並經過社會工作局的電話甄選後符合基本條件的夫婦，本局將透過電話邀請出席座談會。',
                  },
                )}
              </div>
              <div className={px('successMsg')}>
                {/* {intl.formatMessage(
                  {
                    id: '你可登入一戶通查詢本申請進度。',
                  },
                )} */}
                {/* Consulte o processo da candidatura no menu 【Meus assuntos】da Conta Única. */}
                {/* {intl.formatMessage({ id: '你可登入' })}
                <span className={px('green-text')}>一戶通</span>
                {intl.formatMessage({ id: '的【我的辦事】查詢本申請進度。' })} */}
                <div className={px('successMsg')}>
                  {intl.formatMessage({ id: '你可登入' })}
                  <span className={px('green-text')}>{intl.formatMessage({ id: '一戶通' })}</span>
                  {intl.formatMessage({ id: '的【我的辦事】查詢本申請進度。' })}
                </div>
              </div>
            </div>
          </div>
        )}
        {status === 'false' && (
          <div className={px('container')}>
            <div className={px('header')}>
              <div className={px('errorimg')}>
                <div className={px('cross')} />
              </div>
              <div className={px('successWarn')}>
                {intl.formatMessage({ id: '未能成功提交' })}
              </div>
            </div>
            <Divider className={px('dashedDivider')} />
            <div className={px('content')}>
              <div className={px('successInfoArea')}>
                <div className={px('infoItem')}>
                  <div className={px('itemNumber')}>
                    {getMsg(msg)}
                    <br />
                    {intl.formatMessage({ id: '如有疑問，請在社會工作局工作日致電：83997703 / 83997766。' })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <FooterButton
        className={px('footer-button')}
        handleComplete={() => {
          // 关闭当前或上层窗口
          window.location.href = '/foster-apply-list?platform=personal';
        }}
      />
    </>
  );
}
